/**
 * Bulk Order Page
 * Choose style + finish, set quantities, add all to cart at once.
 */

(function() {
  'use strict';

  // ========================================
  // PRODUCT CATALOG
  // Maps style → gang → { standard, combos }
  // Each entry has a display name and Shopify handle
  // ========================================

  const PRODUCT_CATALOG = {
    'Century': {
      '1G': {
        label: 'Single Gang',
        standard: [
          { type: 'Toggle',      handle: 'century-toggle-wall-plate-1' },
          { type: 'Outlet',      handle: 'century-outlet-wall-plate' },
          { type: 'Push Button', handle: 'century-push-button-wall-plate' },
          { type: 'Open',        handle: 'century-open-wall-plate' },
          { type: 'Blank',       handle: 'century-blank-wall-plate' },
          { type: 'Cable',       handle: 'century-cable-wall-plate' },
          { type: 'Push Button Switch', handle: 'the-push-button-switch' }
        ],
        combos: []
      },
      '2G': {
        label: 'Double Gang',
        standard: [
          { type: 'Toggle',      handle: 'century-toggle-wall-plate-double-gang' },
          { type: 'Outlet',      handle: 'century-outlet-wall-plate-double-gang' },
          { type: 'Push Button', handle: 'century-push-button-wall-plate-double-gang' },
          { type: 'Open',        handle: 'century-open-wall-plate-double-gang' }
        ],
        combos: [
          { type: 'Toggle + Outlet', handle: 'century-toggle-outlet-wall-plate-double-gang-1' },
          { type: 'Toggle + Open',   handle: 'century-toggle-open-wall-plate-double-gang' },
          { type: 'Push Button + Outlet', handle: 'century-push-button-outlet-wall-plate-double-gang' },
          { type: 'Push Button + Open',   handle: 'century-push-button-open-wall-plate-double-gang' },
          { type: 'Open + Outlet',        handle: 'century-open-outlet-wall-plate-double-gang' }
        ]
      },
      '3G': {
        label: 'Triple Gang',
        standard: [
          { type: 'Toggle',      handle: 'century-toggle-wall-plate-triple-gang' },
          { type: 'Push Button', handle: 'century-push-button-wall-plate-triple-gang' },
          { type: 'Open',        handle: 'century-open-wall-plate-triple-gang' }
        ],
        combos: [
          { type: 'Toggle + Outlet', handle: 'century-toggle-outlet-wall-plate-triple-gang-1' },
          { type: 'Toggle + Open',   handle: 'century-toggle-open-wall-plate-triple-gang' },
          { type: 'Push Button + Outlet', handle: 'century-push-button-outlet-wall-plate-triple-gang' },
          { type: 'Push Button + Open',   handle: 'century-push-button-open-wall-plate-triple-gang' }
        ]
      },
      '4G': {
        label: 'Quad Gang',
        standard: [
          { type: 'Toggle',      handle: 'century-toggle-wall-plate-four-gang' },
          { type: 'Push Button', handle: 'century-push-button-wall-plate-four-gang' },
          { type: 'Open',        handle: 'century-open-wall-plate-four-gang' }
        ],
        combos: []
      }
    },
    'Futura': {
      '1G': {
        label: 'Single Gang',
        standard: [
          { type: 'Toggle',      handle: 'futura-toggle-wall-plate-1' },
          { type: 'Outlet',      handle: 'futura-outlet-wall-plate' },
          { type: 'Push Button', handle: 'futura-push-button-wall-plate' },
          { type: 'Open',        handle: 'futura-open-wall-plate' },
          { type: 'Blank',       handle: 'futura-blank-wall-plate' },
          { type: 'Cable',       handle: 'futura-cable-wall-plate' },
          { type: 'Push Button Switch', handle: 'the-push-button-switch' }
        ],
        combos: []
      },
      '2G': {
        label: 'Double Gang',
        standard: [
          { type: 'Toggle',      handle: 'futura-toggle-wall-plate-double-gang' },
          { type: 'Outlet',      handle: 'futura-outlet-wall-plate-double-gang' },
          { type: 'Push Button', handle: 'futura-push-button-wall-plate-double-gang' },
          { type: 'Open',        handle: 'futura-open-wall-plate-double-gang' }
        ],
        combos: [
          { type: 'Toggle + Outlet', handle: 'futura-toggle-outlet-wall-plate-double-gang-1' },
          { type: 'Toggle + Open',   handle: 'futura-toggle-open-wall-plate-double-gang' },
          { type: 'Push Button + Outlet', handle: 'futura-push-button-outlet-wall-plate-double-gang' },
          { type: 'Push Button + Open',   handle: 'futura-push-button-open-wall-plate-double-gang' },
          { type: 'Open + Outlet',        handle: 'futura-open-outlet-wall-plate-double-gang' }
        ]
      },
      '3G': {
        label: 'Triple Gang',
        standard: [
          { type: 'Toggle',      handle: 'futura-toggle-wall-plate-triple-gang' },
          { type: 'Push Button', handle: 'futura-push-button-wall-plate-triple-gang' },
          { type: 'Open',        handle: 'futura-open-wall-plate-triple-gang' }
        ],
        combos: [
          { type: 'Toggle + Outlet', handle: 'futura-toggle-outlet-wall-plate-triple-gang' },
          { type: 'Toggle + Toggle + Open', handle: 'futura-tto-wall-plate-triple-gang' },
          { type: 'Push Button + Outlet', handle: 'futura-push-button-outlet-wall-plate-triple-gang' },
          { type: 'Push Button + Open',   handle: 'futura-push-button-open-wall-plate-triple-gang' }
        ]
      },
      '4G': {
        label: 'Quad Gang',
        standard: [
          { type: 'Toggle',      handle: 'futura-toggle-wall-plate-four-gang' },
          { type: 'Push Button', handle: 'futura-push-button-wall-plate-four-gang' },
          { type: 'Open',        handle: 'futura-open-wall-plate-four-gang' }
        ],
        combos: []
      }
    }
  };

  // Display names for finishes (Shopify variant title → customer-facing name)
  const FINISH_DISPLAY = {
    'Polished Brass': 'Polished Brass',
    'Brushed Nickel': 'Satin Nickel',
    'Brushed Brass': 'Satin Brass',
    'Coal Black Brass': 'Coal Black Brass'
  };

  // Products loaded via AJAX (not part of any collection)
  const UNIVERSAL_PRODUCTS = ['the-push-button-switch'];

  // ========================================
  // STATE
  // ========================================

  let state = {
    step: 0,              // 0=initial, 1=style chosen, 2=finish chosen
    style: null,
    finish: null,
    finishCode: null,
    quantities: {},       // { variantId: qty }
    productMap: {},       // { handle: productData }
    initialized: false
  };

  // ========================================
  // INITIALIZATION
  // ========================================

  var universalProductsReady = null;

  function loadUniversalProducts() {
    var fetches = UNIVERSAL_PRODUCTS.map(function(handle) {
      if (state.productMap[handle]) return Promise.resolve();
      return fetch('/products/' + handle + '.js')
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(p) {
          if (!p) return;
          state.productMap[p.handle] = {
            id: p.id,
            title: p.title,
            handle: p.handle,
            available: p.available,
            url: p.url,
            image: p.featured_image,
            variants: p.variants.map(function(v) {
              return {
                id: v.id,
                title: v.title,
                sku: v.sku || '',
                price: v.price,
                available: v.available,
                image: v.featured_image || null
              };
            })
          };
        })
        .catch(function() { /* silently skip unavailable products */ });
    });
    universalProductsReady = Promise.all(fetches);
  }

  function init() {
    // Parse product data from Liquid JSON
    const dataEl = document.getElementById('bulk-order-data');
    if (!dataEl) {
      showEmpty('No product collection selected. Please configure this section in the theme editor.');
      return;
    }

    try {
      const data = JSON.parse(dataEl.textContent);
      if (!data.products || data.products.length === 0) {
        showEmpty('No products found in the selected collection.');
        return;
      }

      // Index products by handle
      data.products.forEach(product => {
        state.productMap[product.handle] = product;
      });

      console.log(`Bulk Order: Loaded ${data.products.length} products`);
    } catch (e) {
      console.error('Bulk Order: Failed to parse product data', e);
      showEmpty('Error loading products.');
      return;
    }

    // Load products not in any collection
    loadUniversalProducts();

    // Bind events
    bindEvents();

    // Start at Step 1 (no pre-selection)
    setStep(1);
    state.initialized = true;

    console.log('Bulk Order initialized');
  }

  // ========================================
  // EVENT BINDING
  // ========================================

  function bindEvents() {
    // Style cards (Step 1)
    const styleCards = document.querySelector('.bulk-order__style-cards');
    if (styleCards) {
      styleCards.addEventListener('click', function(e) {
        const card = e.target.closest('.bulk-order__style-card');
        if (!card) return;
        handleStyleChange(card.dataset.style);
      });
    }

    // Finish cards (Step 2)
    const finishCards = document.querySelector('.bulk-order__finish-cards');
    if (finishCards) {
      finishCards.addEventListener('click', function(e) {
        const card = e.target.closest('.bulk-order__finish-card');
        if (!card || card.style.display === 'none') return;
        handleFinishChange(card.dataset.finish, card.dataset.code);
      });
    }

    // Stepper clicks (go back to completed step)
    var stepper = document.getElementById('bulkOrderStepper');
    if (stepper) {
      stepper.addEventListener('click', function(e) {
        var stepBtn = e.target.closest('.bulk-order__stepper-step.is-completed');
        if (!stepBtn) return;
        var targetStep = parseInt(stepBtn.dataset.goToStep, 10);
        handleStepBack(targetStep);
      });
    }

    // Product grid (delegated for qty buttons, inputs, ADD buttons, and image quick-view)
    const grid = document.getElementById('bulkOrderGrid');
    if (grid) {
      grid.addEventListener('click', function(e) {
        // Quick-view drawer on image tap
        var gridLink = e.target.closest('[data-grid-link]');
        if (gridLink) {
          e.preventDefault();
          var card = gridLink.closest('.product-grid-item');
          if (card) openQuickView(card.dataset.variantId);
          return;
        }

        var addBtn = e.target.closest('.bulk-order__add-btn');
        if (addBtn) {
          setQuantity(addBtn.dataset.variantId, 1);
          return;
        }

        const btn = e.target.closest('.bulk-qty-btn');
        if (!btn) return;

        const variantId = btn.dataset.variantId;
        const action = btn.dataset.action;
        const currentQty = state.quantities[variantId] || 0;

        if (action === 'increment') {
          setQuantity(variantId, currentQty + 1);
        } else if (action === 'decrement' && currentQty > 0) {
          setQuantity(variantId, currentQty - 1);
        }
      });
    }

    // Submit button
    const submitBtn = document.getElementById('bulkSubmit');
    if (submitBtn) {
      submitBtn.addEventListener('click', addAllToCart);
    }
  }

  // ========================================
  // STEP MANAGEMENT & HANDLERS
  // ========================================

  var STEP_LABELS = ['Style', 'Finish', 'Plates'];

  function setStep(newStep) {
    state.step = newStep;

    // Update stepper bar buttons
    var stepperSteps = document.querySelectorAll('.bulk-order__stepper-step');
    stepperSteps.forEach(function(btn) {
      var stepNum = parseInt(btn.dataset.goToStep, 10);
      btn.classList.remove('is-active', 'is-completed');
      btn.disabled = true;

      if (stepNum < newStep) {
        btn.classList.add('is-completed');
        btn.disabled = false;
      } else if (stepNum === newStep) {
        btn.classList.add('is-active');
      }
    });

    // Show/hide content panels
    var panels = document.querySelectorAll('.bulk-order__panel');
    panels.forEach(function(panel) {
      var panelNum = parseInt(panel.dataset.panel, 10);
      panel.style.display = panelNum === newStep ? '' : 'none';
    });

    // Show/hide grid
    var grid = document.getElementById('bulkOrderGrid');
    if (grid) {
      if (newStep >= 3) {
        grid.style.display = '';
        // Trigger entrance animation
        grid.classList.add('is-entering');
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            grid.classList.remove('is-entering');
          });
        });
      } else {
        grid.style.display = 'none';
      }
    }

    updateSummaryValues();

    // Smooth-scroll stepper band to top of viewport on step changes
    if (state.initialized) {
      var stepperBand = document.querySelector('.bulk-order__stepper-band');
      if (stepperBand) {
        stepperBand.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  function updateSummaryValues() {
    var stepperSteps = document.querySelectorAll('.bulk-order__stepper-step');
    stepperSteps.forEach(function(btn) {
      var stepNum = parseInt(btn.dataset.goToStep, 10);
      var textEl = btn.querySelector('.bulk-order__stepper-text');
      if (!textEl) return;

      if (btn.classList.contains('is-completed')) {
        if (stepNum === 1) textEl.textContent = state.style || STEP_LABELS[0];
        else if (stepNum === 2) textEl.textContent = (FINISH_DISPLAY[state.finish] || state.finish) || STEP_LABELS[1];
        else textEl.textContent = STEP_LABELS[stepNum - 1];
      } else {
        textEl.textContent = STEP_LABELS[stepNum - 1];
      }
    });
  }

  function handleStepBack(targetStep) {
    var hasItems = getTotalItems() > 0;

    function doGoBack() {
      // Going back to Step 1 also clears finish
      if (targetStep <= 1) {
        state.finish = null;
        state.finishCode = null;
        // Clear finish card selection
        document.querySelectorAll('.bulk-order__finish-card').forEach(function(card) {
          card.classList.remove('is-selected');
        });
      }

      // Clear quantities and reset grid
      state.quantities = {};
      updateSubtotalBar();
      setStep(targetStep);
    }

    if (hasItems) {
      showConfirm('Changing your selection will reset quantities. Continue?', doGoBack);
    } else {
      doGoBack();
    }
  }

  function handleStyleChange(newStyle) {
    state.style = newStyle;

    // Update style card UI
    document.querySelectorAll('.bulk-order__style-card').forEach(function(card) {
      card.classList.toggle('is-selected', card.dataset.style === newStyle);
    });

    // Handle CBB visibility for finish cards
    var cbbCard = document.querySelector('.bulk-order__finish-card[data-futura-only]');
    if (cbbCard) {
      if (newStyle === 'Century') {
        cbbCard.style.display = 'none';
        // If CBB was selected, clear finish
        if (state.finish === 'Coal Black Brass') {
          state.finish = null;
          state.finishCode = null;
          document.querySelectorAll('.bulk-order__finish-card').forEach(function(card) {
            card.classList.remove('is-selected');
          });
        }
      } else {
        cbbCard.style.display = '';
      }
    }

    // If finish is already valid, skip to Step 3
    if (state.finish && !(newStyle === 'Century' && state.finish === 'Coal Black Brass')) {
      state.quantities = {};
      setStep(3);
      renderGrid();
    } else {
      // Show finish selection
      setStep(2);
    }
  }

  function handleFinishChange(newFinish, newCode) {
    state.finish = newFinish;
    state.finishCode = newCode;

    // Update finish card UI
    document.querySelectorAll('.bulk-order__finish-card').forEach(function(card) {
      card.classList.toggle('is-selected', card.dataset.finish === newFinish);
    });

    state.quantities = {};
    setStep(3);
    renderGrid();
  }

  // ========================================
  // GRID RENDERING
  // ========================================

  function renderGrid() {
    const grid = document.getElementById('bulkOrderGrid');
    if (!grid) return;
    if (!state.style || !state.finish) return;

    // Ensure universal products are loaded before rendering
    if (universalProductsReady) {
      universalProductsReady.then(function() { doRenderGrid(grid); });
    } else {
      doRenderGrid(grid);
    }
  }

  function doRenderGrid(grid) {
    if (!state.style || !state.finish) return;

    grid.innerHTML = '';

    const catalog = PRODUCT_CATALOG[state.style];
    if (!catalog) {
      showEmpty('Unknown style selected.');
      return;
    }

    const gangOrder = ['1G', '2G', '3G', '4G'];
    let hasAnyProducts = false;

    // First pass: standard products by gang size
    gangOrder.forEach(gang => {
      const gangData = catalog[gang];
      if (!gangData) return;

      const standardResolved = gangData.standard
        .map(item => resolveProduct(item))
        .filter(Boolean);

      if (standardResolved.length > 0) {
        hasAnyProducts = true;
        grid.appendChild(renderGangSection(gangData.label, standardResolved, gang));
      }
    });

    // Second pass: combo products by gang size
    gangOrder.forEach(gang => {
      const gangData = catalog[gang];
      if (!gangData) return;

      const comboResolved = gangData.combos
        .map(item => resolveProduct(item))
        .filter(Boolean);

      if (comboResolved.length > 0) {
        hasAnyProducts = true;
        grid.appendChild(renderGangSection(gangData.label + ' \u2014 Combos', comboResolved, gang + '-combo'));
      }
    });

    if (!hasAnyProducts) {
      showEmpty('No products found for this selection.');
    }

    updateSubtotalBar();
  }

  function resolveProduct(item) {
    const product = state.productMap[item.handle];
    if (!product) return null;

    var variant = getVariantForFinish(product, state.finish);
    if (!variant) {
      variant = product.variants.find(function(v) { return v.title === 'Default Title'; });
    }
    if (!variant) return null;

    return { product, variant, displayType: item.type };
  }

  function getVariantForFinish(product, finishName) {
    return product.variants.find(v =>
      v.title.toLowerCase() === finishName.toLowerCase()
    );
  }

  function buildStepperHTML(variantId, qty, displayType) {
    return '<div class="bulk-qty-stepper">'
      + '<button class="bulk-qty-btn bulk-qty-btn--minus" data-action="decrement" data-variant-id="' + variantId + '" aria-label="Decrease quantity">\u2212</button>'
      + '<span class="bulk-qty-num" data-variant-id="' + variantId + '">' + qty + '</span>'
      + '<button class="bulk-qty-btn bulk-qty-btn--plus" data-action="increment" data-variant-id="' + variantId + '" aria-label="Increase quantity">+</button>'
      + '</div>';
  }

  function buildAddBtnHTML(variantId) {
    return '<button class="bulk-order__add-btn" data-variant-id="' + variantId + '">ADD</button>';
  }

  function renderGangSection(title, products, gangKey) {
    var defaultOpen = gangKey === '1G' || gangKey === '2G';
    var section = document.createElement('div');
    section.className = 'bulk-order-gang' + (defaultOpen ? '' : ' is-collapsed-mobile');

    var heading = document.createElement('h3');
    heading.className = 'heading-size-6 bulk-order-gang__heading';
    heading.innerHTML = title + '<span class="bulk-order-gang__chevron" aria-hidden="true"></span>';
    heading.addEventListener('click', function() {
      section.classList.toggle('is-collapsed-mobile');
    });
    section.appendChild(heading);

    var grid = document.createElement('div');
    grid.className = 'js-grid bulk-order-products';
    grid.dataset.gridLarge = '6';
    grid.dataset.gridSmall = '2';

    products.forEach(function(item) {
      grid.appendChild(renderProductCard(item.product, item.variant, item.displayType));
    });

    section.appendChild(grid);
    return section;
  }

  function renderProductCard(product, variant, displayType) {
    const card = document.createElement('div');
    card.className = 'product-grid-item';
    card.dataset.variantId = variant.id;

    const currentQty = state.quantities[variant.id] || 0;
    if (currentQty > 0) card.classList.add('has-quantity');
    if (!variant.available) card.classList.add('sold-out');

    const imageUrl = variant.image || product.image || '';
    const priceFormatted = formatMoney(variant.price);

    card.innerHTML = `
      <div class="product-grid-item__container">
        <a href="${product.url}?variant=${variant.id}" target="_blank" data-grid-link
           aria-label="View ${displayType}">
          <div class="product-grid-item__images" style="--wh-ratio: 1; aspect-ratio: var(--wh-ratio);">
            <div class="product-grid-item__image-wrapper is-active">
              ${imageUrl ? `<img class="product-grid-item__image" src="${imageUrl}" alt="${displayType}" loading="lazy" width="400" height="400">` : ''}
            </div>
          </div>
        </a>
      </div>
      <div class="product__grid__info">
        <div class="product__grid__row">
          <div class="product__grid__text">
            <p class="product__grid__title">${displayType}</p>
            <span class="price">${priceFormatted}</span>
          </div>
          ${variant.available ? `
            <div class="bulk-order__qty-control">
              ${currentQty > 0 ? buildStepperHTML(variant.id, currentQty, displayType) : buildAddBtnHTML(variant.id)}
            </div>
          ` : `
            <em>Sold Out</em>
          `}
        </div>
      </div>
    `;

    return card;
  }

  // ========================================
  // QUANTITY MANAGEMENT
  // ========================================

  function setQuantity(variantId, qty) {
    var oldQty = state.quantities[variantId] || 0;

    if (qty <= 0) {
      delete state.quantities[variantId];
    } else {
      state.quantities[variantId] = Math.min(qty, 99);
    }

    // Update the specific card's control and highlight
    var card = document.querySelector('.product-grid-item[data-variant-id="' + variantId + '"]');
    if (card) {
      card.classList.toggle('has-quantity', qty > 0);

      var control = card.querySelector('.bulk-order__qty-control');
      if (control) {
        if (oldQty === 0 && qty > 0) {
          var titleEl = card.querySelector('.product__grid__title');
          control.innerHTML = buildStepperHTML(variantId, qty, titleEl ? titleEl.textContent : '');
        } else if (qty <= 0 && oldQty > 0) {
          control.innerHTML = buildAddBtnHTML(variantId);
        } else if (qty > 0) {
          var numEl = control.querySelector('.bulk-qty-num');
          if (numEl) numEl.textContent = qty;
        }
      }
    }

    updateSubtotalBar();
    // Sync drawer stepper if open
    var drawerNum = document.querySelector('.bulk-qv-drawer .bulk-qty-num[data-variant-id="' + variantId + '"]');
    if (drawerNum) drawerNum.textContent = Math.max(qty, 0);
  }

  // ========================================
  // QUICK VIEW DRAWER
  // ========================================

  function findProductByVariantId(vid) {
    vid = parseInt(vid);
    for (var product of Object.values(state.productMap)) {
      var variant = product.variants.find(function(v) { return v.id === vid; });
      if (variant) return { product: product, variant: variant };
    }
    return null;
  }

  function openQuickView(variantId) {
    var match = findProductByVariantId(variantId);
    if (!match) return;

    var product = match.product;
    var variant = match.variant;
    var imageUrl = variant.image || product.image || '';
    var priceFormatted = formatMoney(variant.price);
    var currentQty = state.quantities[variant.id] || 0;
    var productUrl = product.url + '?variant=' + variant.id;

    // Find display type from the card
    var card = document.querySelector('.product-grid-item[data-variant-id="' + variantId + '"]');
    var displayType = '';
    if (card) {
      var titleEl = card.querySelector('.product__grid__title');
      if (titleEl) displayType = titleEl.textContent;
    }

    // Remove existing drawer if any
    closeQuickView();

    var overlay = document.createElement('div');
    overlay.className = 'bulk-qv-overlay';

    var drawer = document.createElement('div');
    drawer.className = 'bulk-qv-drawer';
    drawer.style.position = 'relative';
    drawer.innerHTML =
      '<div class="bulk-qv-handle"></div>' +
      '<button class="bulk-qv-close" aria-label="Close">&times;</button>' +
      (imageUrl ? '<div class="bulk-qv-image"><img src="' + imageUrl + '" alt="' + displayType + '"></div>' : '') +
      '<div class="bulk-qv-info">' +
        '<p class="bulk-qv-title">' + displayType + '</p>' +
        '<span class="bulk-qv-price">' + priceFormatted + '</span>' +
      '</div>' +
      (variant.available ?
        '<div class="bulk-qv-stepper">' + buildStepperHTML(variant.id, currentQty || 1, displayType) + '</div>'
        : '<div class="bulk-qv-soldout">Sold Out</div>') +
      '<a href="' + productUrl + '" target="_blank" class="bulk-qv-link">View Product Page &rarr;</a>';

    overlay.appendChild(drawer);
    document.body.appendChild(overlay);

    // If quantity was 0, set to 1 when opening drawer
    if (variant.available && currentQty === 0) {
      setQuantity(variant.id, 1);
    }

    // Animate in
    requestAnimationFrame(function() {
      overlay.classList.add('is-visible');
    });

    // Close on overlay click or close button
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay || e.target.closest('.bulk-qv-close')) closeQuickView();
    });

    // Stepper clicks inside drawer
    drawer.addEventListener('click', function(e) {
      var btn = e.target.closest('.bulk-qty-btn');
      if (!btn) return;
      var vid = btn.dataset.variantId;
      var action = btn.dataset.action;
      var qty = state.quantities[vid] || 0;
      if (action === 'increment') {
        setQuantity(vid, qty + 1);
      } else if (action === 'decrement' && qty > 0) {
        setQuantity(vid, qty - 1);
        if (qty - 1 <= 0) closeQuickView();
      }
    });
  }

  function closeQuickView() {
    var overlay = document.querySelector('.bulk-qv-overlay');
    if (overlay) {
      overlay.classList.remove('is-visible');
      setTimeout(function() { overlay.remove(); }, 300);
    }
  }

  function getTotalItems() {
    return Object.values(state.quantities).reduce((sum, qty) => sum + qty, 0);
  }

  function getSubtotal() {
    let total = 0;
    for (const [variantId, qty] of Object.entries(state.quantities)) {
      // Find the variant price from product map
      for (const product of Object.values(state.productMap)) {
        const variant = product.variants.find(v => v.id === parseInt(variantId));
        if (variant) {
          total += variant.price * qty;
          break;
        }
      }
    }
    return total;
  }

  // ========================================
  // SUBTOTAL BAR
  // ========================================

  function updateSubtotalBar() {
    const footer = document.getElementById('bulkOrderFooter');
    const itemCountEl = document.getElementById('bulkItemCount');
    const subtotalEl = document.getElementById('bulkSubtotal');
    const submitBtn = document.getElementById('bulkSubmit');

    if (!footer) return;

    const totalItems = getTotalItems();
    const subtotal = getSubtotal();

    if (itemCountEl) {
      const typeCount = Object.keys(state.quantities).length;
      var hasNonPlate = UNIVERSAL_PRODUCTS.some(function(handle) {
        var p = state.productMap[handle];
        return p && p.variants.some(function(v) { return state.quantities[v.id]; });
      });
      var unit = hasNonPlate ? 'ITEM' : 'PLATE';
      var text = totalItems === 1 ? '1 ' + unit : totalItems + ' ' + unit + 'S';
      if (totalItems > typeCount) {
        text += ' (' + typeCount + (typeCount === 1 ? ' TYPE' : ' TYPES') + ')';
      }
      itemCountEl.textContent = text;
    }

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(subtotal);
    }

    if (submitBtn) {
      submitBtn.disabled = totalItems === 0;
    }

    // Show/hide footer
    footer.classList.toggle('is-visible', totalItems > 0);
  }

  // ========================================
  // CART SUBMISSION
  // ========================================

  async function addAllToCart() {
    const items = [];

    for (const [variantId, qty] of Object.entries(state.quantities)) {
      if (qty > 0) {
        items.push({ id: parseInt(variantId), quantity: qty });
      }
    }

    if (items.length === 0) return;

    const submitBtn = document.getElementById('bulkSubmit');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.classList.add('loading');
      submitBtn.textContent = 'Adding\u2026';
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || 'Failed to add items to cart');
      }

      // Success — redirect to cart
      window.location.href = '/cart';

    } catch (err) {
      console.error('Bulk Order: Cart error', err);
      alert('There was a problem adding items to your cart: ' + err.message);

      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.classList.remove('loading');
        submitBtn.textContent = 'Add to Cart';
      }
    }
  }

  // ========================================
  // HELPERS
  // ========================================

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function showEmpty(message) {
    const grid = document.getElementById('bulkOrderGrid');
    if (grid) {
      grid.innerHTML = `<div class="bulk-order__empty">${message}</div>`;
    }
  }

  function showConfirm(message, onConfirm) {
    const overlay = document.createElement('div');
    overlay.className = 'bulk-order__confirm-overlay';
    overlay.innerHTML = `
      <div class="bulk-order__confirm-dialog">
        <p>${message}</p>
        <div class="bulk-order__confirm-actions">
          <button class="btn btn--outline btn--cancel">Cancel</button>
          <button class="btn btn--confirm">Continue</button>
        </div>
      </div>
    `;

    overlay.querySelector('.btn--cancel').addEventListener('click', () => {
      overlay.remove();
    });

    overlay.querySelector('.btn--confirm').addEventListener('click', () => {
      overlay.remove();
      onConfirm();
    });

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) overlay.remove();
    });

    document.body.appendChild(overlay);
  }

  // ========================================
  // RUN
  // ========================================

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
